// extracted by mini-css-extract-plugin
module.exports = {"block-card-item":"_80ad21f8ef--block-card-item--1SbOI"};